import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
const Loading = props => {
    const delay = 200;
    const timeOut = 20000;
    const [showLoading, setShowLoadingVisibility] = useState(false);
    const [showErrorPage, setShowErrorPageVisibility] = useState(false);
    useEffect(() => {
        let delayAndTimeout = setTimeout(() => {
            setShowLoadingVisibility(true);
            delayAndTimeout = setTimeout(() => {
                setShowErrorPageVisibility(true);
            }, timeOut);
        }, delay);
        return () => {
            clearTimeout(delayAndTimeout);
        };
    }, []);
    return showLoading && showErrorPage ? (props.componentOnError ? (props.componentOnError) : (_jsx("p", { children: "Er is iets misgegaan: het systeem reageert niet. Probeer het later opnieuw of neem contact op met de helpdesk." }))) : showLoading ? (_jsx("div", Object.assign({ className: "spinner-border spinner-border-sm text-primary" }, { children: _jsx("span", Object.assign({ className: "sr-only" }, { children: "Bezig met laden..." })) }))) : null;
};
export default Loading;
